import React, { useEffect, useState } from 'react';
import { Settings } from 'lucide-react';
import API from '../../api';


function NoticShow() {
      const [notices, setNotices] = useState([]);
  const [loadingNotices, setLoadingNotices] = useState(true);

  // Fetch notices on mount
useEffect(() => {
  const fetchNotices = async () => {
    try {
      const res = await API.get('/notices');
      const sortedNotices = res.data
        .sort((a, b) => new Date(b.date) - new Date(a.date)) // 📌 Sort by date DESC
        .slice(0, 5); // Optional: limit to latest 5
      setNotices(sortedNotices);
    } catch (err) {
      console.error('Failed to load notices:', err);
    } finally {
      setLoadingNotices(false);
    }
  };
  fetchNotices();
}, []);
  return (
      <div className="bg-white rounded-xl shadow-lg p-6">
        <h2 className="flex items-center text-xl font-semibold text-gray-900 mb-4">
          <Settings className="w-6 h-6 text-yellow-500 mr-2" />
          Latest Notices
        </h2>

        {loadingNotices ? (
          <p className="text-gray-600">Loading notices...</p>
        ) : notices.length === 0 ? (
          <p className="text-gray-500">No notices posted yet.</p>
        ) : (
          <ul className="space-y-4 max-h-56 overflow-y-auto">
            {notices.map((notice) => (
              <li key={notice.id} className="border-b border-gray-200 pb-2">
                <h3 className="text-md font-semibold text-blue-700">{notice.heading}</h3>
                <p className="text-xs text-gray-500 mb-1">{new Date(notice.date).toLocaleDateString()}</p>
                <p className="text-sm text-gray-700 line-clamp-2">{notice.content}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
  )
}

export default NoticShow;
